import { FieldWrapper, FieldWrapperProps } from './field-wrapper';
import { useController, UseControllerProps, FieldValues } from 'react-hook-form';
import { FlatSelectProps, SelectInputFlat } from 'shared/ui/controls';

export interface SelectFieldProps<T extends FieldValues, V = string>
  extends UseControllerProps<T>,
    Omit<FlatSelectProps<V>, 'value' | 'onChange' | 'onDelete' | 'label'>,
    Pick<FieldWrapperProps, 'label' | 'labelSize' | 'required'> {
  onDelete?: (id: V) => void;
}

export const SelectInputFieldFlat = <T extends FieldValues, V = string>({
  label,
  options,
  required,
  labelSize = 'l',
  btnSize,
  onDelete,
  multiple,
  showCheckbox,
  checkboxPosition,
  ...props
}: SelectFieldProps<T, V>) => {
  const {
    field,
    fieldState: { error }
  } = useController(props);

  return (
    <FieldWrapper label={label} error={error} labelSize={labelSize} required={required}>
      <SelectInputFlat
        btnSize={btnSize}
        options={options}
        value={field.value}
        onChange={field.onChange}
        onDelete={onDelete}
        multiple={multiple}
        showCheckbox={showCheckbox}
        checkboxPosition={checkboxPosition}
        {...props}
      />
    </FieldWrapper>
  );
};
